import { render, staticRenderFns } from "./JobCompanyComponent.vue?vue&type=template&id=615f3770&scoped=true"
import script from "./JobCompanyComponent.vue?vue&type=script&lang=ts"
export * from "./JobCompanyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f3770",
  null
  
)

export default component.exports